export default __webpack_public_path__ + "static/media/Queerflexiv.c7260231.mp4";